export default "__VITE_ASSET__DXjhjGym__"